var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4834 28.5833C12.8167 25.1833 16.1167 22.75 20.0001 22.75C23.8834 22.75 27.1834 25.1833 28.5167 28.5833H11.4834Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.084 18.082C15.4173 18.082 16.584 16.9154 16.584 15.582V13.082L11.584 15.582C11.584 16.9154 12.7507 18.082 14.084 18.082Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.209 18.082C23.8757 18.082 22.709 16.9154 22.709 15.582V13.082L27.709 15.582C27.709 16.9154 26.5423 18.082 25.209 18.082Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBad);
export default __webpack_public_path__ + "static/media/IconBad.1f4b860b30deba97e25847d2e02f7323.svg";
export { ForwardRef as ReactComponent };